// extracted by mini-css-extract-plugin
export default {"container":"ChatApp_container__+oB2a"};